/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import Container from './Container';
import './index.css';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <StrictMode>
    <Container
      customTheme={{}}
      appName='Das Kindermissionswerk ‚Die Sternsinger’ e.V.'
    />
  </StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
